export default "__VITE_ASSET__DTQFqHDn__"